/**
 * @file 获取websocket token信息
 * @date 2023-10-25
 */

import { userapi } from '@/apis/api2';

// 用于存储请求Promise的缓存对象，避免多次请求
const promiseCache = {};

/**
 * @param {boolean} isForce // 是否清除Promise缓存，默认false，用于并发请求时，过滤相同请求；设为true，用于重连时发起新的请求；
 * @param {number} maxRetries // 重试的最大次数
 */
export const getWsToken = (isForce, maxRetries = 3) => new Promise((resolve) => {
    // 重连时，清除Promise缓存，发起新的请求
    if (isForce) {
        delete promiseCache.getWsToken;
    }

    // 已重连次数
    let retryCount = 0;

    // 处理接口返回信息
    const callback = (res, retryHandler) => {
        const { success, result } = res;
        if (success && result) {
            resolve(result);
        } else if (retryCount < maxRetries) {
            // 如果尝试次数未达到最大值，随机500~3000毫秒间隔后重连
            retryCount += 1;
            const randomDelay = Math.floor(Math.random() * 2500) + 500; // 生成500~300毫秒之间的随机延迟
            setTimeout(retryHandler, randomDelay);
        } else {
            // 重试3次请求 ott 接口，尝试maxRetries次失败后增加埋点
            window.Monitor?.log({ tokenType: 'retryFailed' });
        }
    };

    // 获取缓存的Promise返回结果
    const getPromiseCacheResult = async (retryHandler) => {
        const res = await promiseCache.getWsToken;
        callback(res, retryHandler);
    };

    // 首次发起请求/获取接口数据失败重试
    const retry = () => {
        promiseCache.getWsToken = userapi.getWsToken();
        getPromiseCacheResult(retry);
    };

    // 开始获取ws token，本方法用于规避new Promise不允许直接传入async方法；
    const getToken = () => {
        if (promiseCache.getWsToken) {
            getPromiseCacheResult(retry);
            return;
        }

        retry();
    };

    // 执行
    getToken();
});
